import type { AxiosError, InternalAxiosRequestConfig } from 'axios';
import qs from 'qs';
import { isDevEnv } from '@/config/utils';

export function logResponseErrorInterceptor(e: AxiosError) {
  if (!isDevEnv()) return;

  const locationString = [
    e.config?.url,
    '',
    '',
    e.request?.data,
    '',
  ].filter(Boolean).join('\n');

}

export function logRequestInterceptor(config: InternalAxiosRequestConfig) {
  if (!isDevEnv()) return config;

  const pic = {
    patch: '◆',
    post: '◆',
    put: '◆',
    get: '■︎',
    delete: '✕',
  }[config.method];
  const method = config.method.toUpperCase().concat(' '.repeat(7 - config.method.length));
  const q = config.params ? `?${qs.stringify(config.params)}` : '';


  return config;
}